<template>
  <fts-design-modal
    width="1280px"
    append-content-class="dm-stepper"
    class="fts-standard-activity-design-modal"
    ref="ftsDesignModal"
  >
    <!-- title -->
    <template #title>
      <div class="design-modal-header-std__title">
        <div class="design-modal-header-name design-modal-header-name--flex-1">{{formData.name}}</div>
      </div>
    </template>
    <!-- description -->
    <template #description>
      <span class="design-modal-header-tag">Basic</span>
      <span
        class="design-modal-header-description"
      >designing the form for standard activities like create, edit or view</span>
    </template>
    <!-- body -->
    <template #body>
      <!-- content -->
      <!-- section nav (§3.2b ledger text; replaces the bottom stepper) -->
      <div class="dm-nav-ledger">
        <template v-for="(tab, ti) in navSections">
          <span class="dm-nav-ledger-sep" v-if="ti" :key="tab.key + '-sep'">·</span>
          <span
            class="dm-nav-ledger-item"
            :class="{ 'dm-nav-ledger-item--on': step === tab.key }"
            @click="setStep(tab.key)"
            :key="tab.key"
          >{{ tab.label }}<sup class="dm-nav-ledger-beta" v-if="tab.beta">beta</sup></span>
        </template>
      </div>
      <div class="dm-stepper-content">
        <!-- description -->
        <div class="design-modal-form-group" v-if="formData.description">
          <div class="design-modal-body-description">{{formData.description}}</div>
        </div>
        <!-- form -->
        <div v-if="step === 'form' && standardWithWorkDesign">
          <!-- form -->
          <fts-form-designer
            :modules="modules"
            :activity-id="formData.id"
            :form="formData.design"
            :activity="formData"
            :is-form-view="(formData.id === 'view' || formData.id === 'quickView') || !isCapableWrite"
            :is-capable-add-information="isCapableAddInformation"
            @form:delete="deleteFormDesign"
            @save="done(true, true)"
            v-if="formData.design"
          />
          <!-- form:create -->
          <div class="dm-form-design-create" @click="createWorkDesign" v-else>
            <!-- click to add form -->
            <i class="fts-icon-form dm-form-design-create-icon"></i>
            <div class="dm-form-design-create-plus">
              <font-awesome-icon :icon="['fas', 'plus']" />
            </div>
          </div>
        </div>
        <!-- form automation -->
        <div v-else-if="step === 'automation' && formData.design">
          <fts-form-automation-section
            :form="formData.design"
            :activity-id="formData.id"
            save-button
            @save="done(true, true)"
          />
        </div>
        <!-- script (beta) -->
        <div v-else-if="step === 'script' && beta && formData.design">
          <fts-release-badge class="fts-float-right" />
          <fts-form-script
            :form-data="formData.design"
            :information="information"
            :save-button="!!saveCallBack"
            @save="done(true, true)"
          />
        </div>
        <!-- flow -->
        <!-- <div v-else-if="step === 'flow' && isWorkflow">

          <div class="dm-stepper-control">
            <div class="dm-stepper-description">
              <div>User creates an entry by submitting form above. Indicate below whether the entry has an inistate everytime an new entry created. You may always change the configuration in a later time.</div>
              <div>Hint: For entry that does not have a process, you may safely ignore. If it is a workflow or process, you may start by creating the initial state.</div>
            </div>

            <div class="dm-stepper-control-outer" v-if="!builder">
              <fts-btn
                color="primary"
                sm
                outline
                rounded
                text-transform-init
                @click="openWorkflow"
              >Show Diagram</fts-btn>
            </div>
          </div>

          <div class="fts-flow-display dm-flow-display">
            <div class="dm-flow-wrapper">

              <div class="dm-flow-state-start">start</div>

              <font-awesome-icon
                :icon="['fas', 'right-long']"
                class="dm-flow-display-direction"
              />

              <fts-activity-design-inline
                :activity="{
                    name: 'create' 
                  }"
                :navigatable="false"
              />

              <font-awesome-icon
                :icon="['fas', 'right-long']"
                class="dm-flow-display-direction"
              />

              <fts-state-design-inline
                v-model="stateFormData.id"
                :list="states"
                initial-state
                :initial-edit-mode="!stateFormData.id"
                @navigate="navigateStateDesign"
                @navigate:activity="navigateNewActivityDesign"
              />
            </div>
          </div>
        </div> -->
        <!-- setting -->
        <!-- AI: how the AI TeamMate performs this activity -->
        <div v-else-if="step === 'ai'">
          <div class="fts-row gutters" v-if="supportsActor">
            <div class="fts-col">
              <fts-form-element
                :form-data="formData"
                :item="{
                  fieldName: 'actor',
                  displayName: 'AI TeamMate actor',
                  icon: 'fts-icon-user',
                  helper: 'Who performs this activity when it is requested through the AI TeamMate. Default: AI for create and edit (performed directly); Hybrid for the rest (the user confirms). Set Human to make the TeamMate open the form for the user instead.'
                }"
                comfort-design
              >
                <select
                  slot="formElement"
                  slot-scope="{ formData }"
                  v-model="formData.actor"
                  class="fts-form-control"
                >
                  <option value="">Default</option>
                  <option value="ai">AI — performs it directly</option>
                  <option value="hybrid">Hybrid — the user confirms</option>
                  <option value="human">Human — opens the form for the user</option>
                </select>
              </fts-form-element>
            </div>
          </div>
          <!-- §4.3.3 form-level GNey actions (internal alpha) -->
          <template v-if="isInternal && supportsAiActions">
            <div class="dm-group-label">
              GNey actions <fts-release-badge alpha class="fts-align-top" />
            </div>
            <div class="ai-actions-hint">
              Buttons shown on this form. Clicking one asks GNey to fill or rewrite fields per
              the instruction — the user sees what changed and can undo. Costs AI credits per
              click.
            </div>
            <div
              class="ai-actions-row"
              v-for="action in aiActions"
              :key="action.id"
            >
              <input
                type="text"
                class="fts-form-control ai-actions-row__label"
                placeholder="Button label"
                v-model="action.label"
              />
              <textarea
                class="fts-form-control ai-actions-row__instruction"
                rows="2"
                placeholder="e.g. Summarize the description into the summary field"
                v-model="action.instruction"
              ></textarea>
              <select
                class="fts-form-control ai-actions-row__seniority"
                v-model="action.seniority"
              >
                <option value="junior">Junior</option>
                <option value="senior">Senior</option>
                <option value="expert">Expert</option>
                <option value="consultant">Consultant</option>
              </select>
              <fts-btn icon text @click="removeAiAction(action)">
                <font-awesome-icon :icon="['far', 'trash-alt']" />
              </fts-btn>
            </div>
            <fts-btn sm outline color="primary" text-transform-init @click="addAiAction">
              <font-awesome-icon :icon="['fas', 'plus']" /> Add GNey action
            </fts-btn>
          </template>
        </div>
        <div v-else-if="step === 'setting'">
          <div class="dm-group-label">Access &amp; listing</div>
          <div class="fts-row gutters">
            <!-- menus -->
            <div class="fts-col">
              <fts-form-element
                :formData="formData"
                :item="{
                  fieldName: 'menus',
                  displayName: 'Listing',
                  icon: 'fts-icon-menu-caret-down',
                  helper: 'To restrict access to specific listings for this activity.'
                }"
                comfort-design
              >
                <fts-select
                  slot="formElement"
                  slot-scope="{formData, item}"
                  :form-data="formData"
                  :item="item"
                  :options="menus"
                  multiple
                  comfort-design
                >
                  <fts-label-group
                    slot="selected-option-container"
                    slot-scope="{ option }"
                    :item-id="option.id"
                    :list="menus"
                    emoji
                  />
                  <fts-label-group
                    slot="option"
                    slot-scope="{ option }"
                    :item-id="option.id"
                    :list="menus"
                    emoji
                  />
                </fts-select>
              </fts-form-element>
            </div>
          </div>
          <fts-ledger-toggle-row
            :form-data="formData"
            field-name="internal"
            label="For automation only"
          />
          <div class="dm-group-label">After submit</div>
          <!-- Create only: the other standard activities keep the standard form in Phase 1 (PD-12). -->
          <fts-activity-portal-row
            :form-data="formData"
            v-if="formData.id === 'create' && (isInternal || formData.portalId)"
          />
          <div class="fts-row gutters">
            <!-- message -->
            <div class="fts-col" v-if="beta">
              <fts-form-element
                :form-data="formData"
                :item="{
                  type: 32,
                  displayName: 'Message',
                  fieldName: 'message',
                  helper: 'To show message after submission.'
                }"
                comfort-design
              >
                <template #formLabel="{ label }">
                  {{ label }} <fts-release-badge class="fts-align-top" />
                </template>
                <fts-formula
                  slot="formElement"
                  :template="true"
                  slot-scope="{ formData, item }"
                  :variables="variables"
                  v-model="formData[item.fieldName]"
                />
              </fts-form-element>
            </div>
            <!-- document -->
            <div class="fts-col fts-col-md-6" v-if="isInternal">
              <fts-form-element
                :form-data="formData"
                :item="{
                  fieldName: 'documentId',
                  displayName: 'Document',
                  icon: 'fts-icon-menu-caret-down',
                }"
                comfort-design
              >
                <template #formLabel="{ label }">
                  {{label}} <fts-release-badge alpha class="fts-align-top" />
                </template>
                <fts-select
                  slot="formElement"
                  slot-scope="{ formData, item }"
                  :form-data="formData"
                  :item="item"
                  :options="documents"
                  comfort-design
                />
              </fts-form-element>
            </div>
          </div>
          <div class="dm-group-label">History &amp; engine</div>
          <fts-ledger-toggle-row
            :form-data="formData"
            field-name="skipHistory"
            label="History"
            off-label="Recorded"
            on-label="Skipped"
          />
          <fts-ledger-toggle-row
            :form-data="formData.design"
            field-name="enforceViewAutomation"
            label="Run automation &amp; script on view"
            :helper="viewAutomationHelper"
            :disabled="viewAutomationLocked"
            default-on
            v-if="showViewAutomationToggle"
          />
          <fts-server-native-row
            :activity="formData"
            :activity-id="formData.id"
            @verdict="nativeVerdict = $event"
            v-if="formData.design"
          />
        </div>
      </div>
      <!-- footer (temp) -->
      <div
        class="dm-stepper-footer"
        v-if="$v.formData && $v.formData.design && $v.formData.design.$error"
      >
        <div class="dm-stepper-footer-outer">
          <div
            class="dm-stepper-message dm-stepper-message--error"
          >Form cannot be empty. Form at least must have information or element.</div>
        </div>
      </div>
    </template>
    <!-- footer -->
    <template #footerLeft>
      <!-- auth -->
      <fts-auth
        type="activity"
        :unit-id="formData.id"
        :title="formData.name"
        preview-placement="top"
      >
        <fts-btn
          slot="trigger"
          slot-scope="{ show, isRight }"
          text
          icon
          :color="isRight ? 'danger' : 'default'"
          @click="show"
        >
          <font-awesome-icon :icon="['fas', 'lock']" v-if="isRight" />
          <font-awesome-icon :icon="['fas', 'unlock']" v-else />
        </fts-btn>
      </fts-auth>
    </template>
    <template #footerRight>
      <!-- cancel -->
      <fts-btn text @click="beforeClose">Cancel</fts-btn>
      <!-- save -->
      <fts-btn color="primary" text @click="done(true)" v-if="Boolean(saveCallBack)">
        <font-awesome-icon :icon="['fas', 'check']" />Save
      </fts-btn>
      <!-- done -->
      <fts-btn outline color="primary" @click="done">
        <font-awesome-icon :icon="['fas', 'check']" />Ok
      </fts-btn>
    </template>
  </fts-design-modal>
</template>

<script>
import Vue from "vue";
import Vuelidate from "vuelidate";
Vue.use(Vuelidate);

import changesets from "diff-json";

import { authorizationStore } from "../store/authorizationStore";
import commons from "../commons/commons";
import canvasDesign from "../commons/canvasDesign";
import validator from "../commons/designValidator";

import FTSDesignModal from "./FTSDesignModal";
import FTSAuth from "./FTSAuth";
import FTSBtn from "../elements/FTSBtn";
import FTSCollapsibleElement from "../elements/FTSCollapsibleElement";
import FTSFormElement from "../elements/FTSFormElement";
import FTSSelect from "../elements/FTSSelect";
import FTSLabelGroup from "../elements/FTSLabelGroup";
import FTSFormDesigner from "../elements/FTSFormDesigner";
import FTSTransitionExpand from "../elements/FTSTransitionExpand";
import FTSTippy from "../elements/FTSTippy";
import FTSFormScript from "./FTSFormScript";
import FTSFormAutomationSection from "./FTSFormAutomationSection";
import FTSLedgerToggleRow from "./FTSLedgerToggleRow";
import FTSActivityPortalRow from "./FTSActivityPortalRow";
import FTSServerNativeRow from "./FTSServerNativeRow";
import FTSStateDesignInline from "./FTSStateDesignInline";
import FTSActivityDesignInline from "./FTSActivityDesignInline";
import FTSFormula from "./FTSFormula";

export default {
  props: {
    builder: Boolean,
    isCapableWrite: {
      type: Boolean,
      default: true
    },
    isCapableWorkflow: {
      type: Boolean,
      default: true
    },
    isCapableAddInformation: {
      type: Boolean,
      default: true
    }
  },
  components: {
    "fts-design-modal": FTSDesignModal,
    "fts-auth": FTSAuth,
    "fts-btn": FTSBtn,
    "fts-collapsible-element": FTSCollapsibleElement,
    "fts-form-element": FTSFormElement,
    "fts-select": FTSSelect,
    "fts-label-group": FTSLabelGroup,
    "fts-form-designer": FTSFormDesigner,
    "fts-transition-expand": FTSTransitionExpand,
    "fts-tippy": FTSTippy,
    "fts-form-script": FTSFormScript,
    "fts-form-automation-section": FTSFormAutomationSection,
    "fts-ledger-toggle-row": FTSLedgerToggleRow,
    "fts-activity-portal-row": FTSActivityPortalRow,
    "fts-server-native-row": FTSServerNativeRow,
    "fts-state-design-inline": FTSStateDesignInline,
    "fts-activity-design-inline": FTSActivityDesignInline,
    "fts-formula": FTSFormula
  },
  data: () => ({
    step: null,
    formData: null,
    // FormulaNative verdict relayed by the server-native row (viewVisibilityNative etc.)
    nativeVerdict: null,
    stateFormData: null,
    originalData: null,
    resolve: null,
    saveCallBack: null,
    navigateCallback: null,
    params: null,
    advanced: false
  }),
  validations() {
    let formData = {};
    formData = validator.standardDesign();
    return { formData };
  },
  methods: {
    /* §4.3.3 form-level GNey actions */
    addAiAction() {
      const design = this.formData && this.formData.design;
      if (!design) return;
      if (!Array.isArray(design.aiActions)) {
        this.$set(design, "aiActions", []);
      }
      design.aiActions.push({
        id: commons.newUUID(),
        label: "",
        instruction: "",
        seniority: "junior",
      });
    },
    removeAiAction(action) {
      const design = this.formData && this.formData.design;
      if (!design || !Array.isArray(design.aiActions)) return;
      const index = design.aiActions.indexOf(action);
      if (index > -1) design.aiActions.splice(index, 1);
      if (!design.aiActions.length) this.$delete(design, "aiActions");
    },
    async show(item, saveCallBack, navigateCallback, params) {
      this.saveCallBack = saveCallBack;
      this.navigateCallback = navigateCallback;
      this.formData = _.cloneDeep(item);

      /* §4.3.3: rows saved before the seniority picker existed get the junior default so the
         select binds */
      if (this.formData.design && Array.isArray(this.formData.design.aiActions)) {
        this.formData.design.aiActions.forEach((action) => {
          if (action && !action.seniority) this.$set(action, "seniority", "junior");
        });
      }
      this.params = params;

      /* ensure the actor key exists so the selector binds reactively (empty = use the
         platform default: AI for create/edit, Hybrid for the rest) */
      if (!("actor" in this.formData)) {
        this.$set(this.formData, "actor", "");
      }

      const { t, tid } = this.$route.query;
      if (!t && !tid) {
        commons.addDesignQueryParams(this.$router, this.$route, [
          { name: "t", value: "standardActivity" },
          { name: "tid", value: this.formData.id }
        ]);
      }

      /* step */
      if (this.params && this.params.step && ['form', 'automation', 'script', 'ai', 'setting'].indexOf(this.params.step) > -1) {
        this.step = this.params.step;
      } else if (this.standardWithWorkDesign) {
        this.step = "form";
      } else if (this.isWorkflow) {
        this.step = "flow";
      }
      /* form design */
      if (this.formData.design && this.formData.design.rows) {
        commons.expandWorkDesign(this.information, this.formData.design);
        if (!this.formData.design.payload) {
          this.$set(this.formData.design, "payload", {});
        }
        /* enforceViewAutomation is tri-state on the server: absent means RUN (so no existing
           module changed behaviour when the toggle shipped). Seed the absent case to true here —
           before the originalData snapshot below, so it never marks the form dirty — otherwise the
           switch would read "off" while the server is still running the script on every view.
           Only where the toggle is actually shown, so forms with nothing to gate stay untouched. */
        if (
          this.showViewAutomationToggle &&
          !("enforceViewAutomation" in this.formData.design)
        ) {
          this.$set(this.formData.design, "enforceViewAutomation", true);
        }
      } else if (this.formData.design) {
        this.$delete(this.formData, "design");
      }
      /* state form data */
      if (
        this.formData.id === "createEditView" ||
        this.formData.id === "create"
      ) {
        this.stateFormData = {};
        const state = this.states.find(x => x.initial);
        if (state && state.id) {
          this.$set(this.stateFormData, "id", state.id);
        }
      }

      return new Promise(resolve => {
        this.resolve = resolve;
        this.$refs.ftsDesignModal.show({
          beforeCloseHandler: () => {
            const diff = changesets.diff(this.formData, this.originalData);
            if (diff && diff.length) {
              this.$modal.show("dialog", {
                title: "Confirm discard changes",
                text: "Discard all changes?",
                buttons: [
                  { title: "Cancel" },
                  {
                    title: "Discard",
                    default: true,
                    handler: () => {
                      this.$modal.hide("dialog");
                      this.reset();
                    }
                  }
                ]
              });
            } else {
              this.reset();
            }
          }
        });

        this.$nextTick(() => {
          this.originalData = _.cloneDeep(this.formData);
        });

        if (
          (
            this.formData.id === "createEditView" ||
            this.formData.id === "create"
          ) &&
          !Boolean(this.formData.design && Array.isArray(this.formData.design.rows) && this.formData.design.rows.some(x => Array.isArray(x.items) && x.items.some(y => y.id))) &&
          !Boolean(this.information && this.information.length)
        ) {
          this.createWorkDesign();
        }
      });
    },
    done(save, enableToast) {
      this.$v.formData.$touch();

      if (this.$v.formData.$invalid) {
        if (enableToast) {
          this.$toasted.error("Configuration error. Please ensure all values are in a proper format.");
        }
        return;
      }

      const formData = _.cloneDeep(this.formData);
      if (save) {
        this.saveCallBack && this.saveCallBack(formData);
        this.originalData = _.cloneDeep(this.formData);
      } else {
        this.resolve && this.resolve(formData);
        this.reset();
      }
    },
    navigateContinue(type, item, params) {
      this.$v.formData.$touch();
      if (!this.$v.formData.$invalid) {
        const formData = _.cloneDeep(this.formData);
        const navigateCallback = Object.assign(this.navigateCallback);
        /* reset */
        this.reset();
        /* navigate */
        navigateCallback && navigateCallback(formData, type, item, params);
      }
    },
    beforeClose() {
      this.$refs.ftsDesignModal.beforeClose();
    },
    remove() {
      this.$modal.show("dialog", {
        title: "Confirmation",
        text: `Delete ${this.formData.name}?`,
        buttons: [
          { title: "Cancel" },
          {
            title: "Remove",
            default: true,
            handler: () => {
              this.$modal.hide("dialog");
              this.resolve && this.resolve(true);
              this.reset();
            }
          }
        ]
      });
    },
    reset() {
      const { t, tid } = this.$route.query;
      if (t === "standardActivity" && tid === this.formData.id) {
        commons.removeDesignQueryParams(this.$router, this.$route, ["t", "tid"]);
      }

      this.$v.$reset();
      this.$refs.ftsDesignModal.close();
      Object.assign(this.$data, this.$options.data.apply(this));
    },
    createWorkDesign() {
      this.$set(this.formData, "design", {
        rows: [{ index: 0, items: [] }],
        backendScript: "",
        payload: "{}"
      });
    },
    deleteFormDesign() {
      this.$delete(this.formData, "design");
    },
    navigateStateDesign(id) {
      const result = this.states.find(x => x.id === id);
      if (result) this.navigateContinue(canvasDesign.state, result);
      else this.$toasted.error("Something went wrong. State not found.");
    },
    navigateNewActivityDesign(id) {
      const params = { fromStateId: id, disableContinue: true };
      this.navigateContinue(canvasDesign.activity, null, params);
    },
    openWorkflow() {
      this.$openStudioWorkflow && this.$openStudioWorkflow();
    },
    setStep(step) {
      this.step = step;
    }
  },
  watch: {
    /* a section can disappear (e.g. the form design is removed while its tab is open) —
       fall back to the first available one */
    navSections(list) {
      if (list.length && !list.some((t) => t.key === this.step)) {
        this.step = list[0].key;
      }
    }
  },
  computed: {
    /* top ledger nav (§3.2b): Form · Automation (form automation) · Script (beta) · Advanced */
    navSections() {
      if (!this.formData) return [];
      const tabs = [];
      if (this.standardWithWorkDesign) {
        tabs.push({ key: 'form', label: 'Form' });
        if (this.formData.design) {
          tabs.push({ key: 'automation', label: 'Automation' });
          if (this.beta) tabs.push({ key: 'script', label: 'Script', beta: true });
        }
      }
      if (this.supportsActor || this.supportsAiActions) tabs.push({ key: 'ai', label: 'AI' });
      tabs.push({ key: 'setting', label: 'Advanced' });
      return tabs;
    },
    variables() {
      return [
        {
          name: "Entry",
          fieldName: "entry",
          type: 35,
          moduleId: this.$store.state.vectorId.toString()
        }
      ];
    },
    isInternal() {
      return authorizationStore.getters.isInternal;
    },
    /* §4.3.3 form-level GNey actions — the design's aiActions list (created on demand) */
    aiActions() {
      const design = this.formData && this.formData.design;
      return (design && design.aiActions) || [];
    },
    beta() {
      return (
        authorizationStore.getters.isBeta || this.$store.getters.workspaceBeta
      );
    },
    modules() {
      return this.$store.getters.workspaceModules;
    },
    information() {
      return this.$store.getters.canvasInformation;
    },
    menus() {
      return this.$store.getters.canvasMenus.map(x => ({
        id: x.id,
        name: x.name,
        emoji: x.emoji
      }));
    },
    documents() {
      return this.$store.getters.canvasDocuments; 
    },
    states() {
      return this.$store.getters.canvasStates;
    },
    standardWithWorkDesign() {
      return (
        this.formData &&
        [
          "createEditView",
          "createUpdate",
          "create",
          "edit",
          "quickView",
          "view"
        ].indexOf(this.formData.id) > -1
      );
    },
    /* standard activities the AI TeamMate can submit — only these expose an actor selector
       (view/quickView/etc. are read-only and never submitted, so an actor is meaningless) */
    supportsActor() {
      return (
        this.formData &&
        [
          "create",
          "edit",
          "delete",
          "changeStatus",
          "comment",
          "duplicate",
          "manage"
        ].indexOf(this.formData.id) > -1
      );
    },
    /* §4.3.3 form-level GNey actions attach to the FORM, not the actor — so they apply to every
       standard activity that carries a designed form, including the default combined
       createEditView. view/quickView are excluded: they are read-only, and the runtime only
       renders the buttons on an editable form, so configuring them there could never do
       anything. */
    supportsAiActions() {
      return !!(
        this.formData &&
        this.formData.design &&
        ["view", "quickView"].indexOf(this.formData.id) === -1
      );
    },
    isWorkflow() {
      return (
        this.isCapableWorkflow &&
        (this.formData.id === "createEditView" || this.formData.id === "create")
      );
    },
    /* Ruling 2026-08-23: visibility conditions ALWAYS evaluate on view (SS06020 — the toggle
       gates exactly what its name says, automation & script), and "off" is only offered when
       every visibleFormula on this form is server-native so the suppressed view can be served
       from stored data. The verdict (FormulaNative, via the server-native row) classifies the
       SAVED canvas; a form already off stays switchable back on. */
    viewAutomationLocked() {
      const design = this.formData && this.formData.design;
      if (!design || design.enforceViewAutomation === false) return false;
      return Boolean(this.nativeVerdict) && this.nativeVerdict.viewVisibilityNative === false;
    },
    viewAutomationHelper() {
      const base =
        "This form also serves view and quick view, so by default its automation blocks, backend script and formulas all run on every read. Turn this off to run them on create and edit only — a record opened to view is then read straight from the database and shows exactly what was saved, which is much faster. Visibility conditions still apply on view either way.";
      if (!this.viewAutomationLocked) return base;
      const fields = (this.nativeVerdict && this.nativeVerdict.nonNativeVisibleFields) || [];
      const named = fields.length ? ` (${fields.join(", ")})` : "";
      return `${base} Can't be turned off yet: the visibility conditions on this form${named} are not server-native, so a view would still need the full runtime. Turn on server-native formulas (or rewrite those conditions), save, and try again.`;
    },
    /* The default (createEditView) form serves view / quickView when there is no dedicated
       view form, so its backendScript / automation / formulas would otherwise run on every
       read. Surface the toggle (design.enforceViewAutomation) only on that default form AND
       only when it actually carries runtime work to gate — otherwise the toggle is
       meaningless. Dedicated view/quickView forms always run their own configured runtime, so
       they need no toggle. Mirrors ViewAutomationGate.ResolveWork on the server. */
    showViewAutomationToggle() {
      const design = this.formData && this.formData.design;
      if (!design || this.formData.id !== "createEditView") return false;
      const script =
        typeof design.backendScript === "string" ? design.backendScript.trim() : "";
      const hasScript = script !== "" && script !== "calculate()";
      const hasAutomation = Boolean(
        design.automation &&
          design.automation.blocks &&
          Object.keys(design.automation.blocks).length
      );
      return hasScript || hasAutomation || this.hasViewGatedFormula;
    },
    /* Any formula that makes the form recompute on open — the same five properties the
       server's NeedSync scan enumerates, columns included. */
    hasViewGatedFormula() {
      const design = this.formData && this.formData.design;
      if (!design || !Array.isArray(design.rows)) return false;
      const types = [
        "formula",
        "visibleFormula",
        "validateFormula",
        "readOnlyFormula",
        "requiredFormula"
      ];
      const withFormula = item =>
        Boolean(item) && types.some(type => Boolean(item[type]) && String(item[type]).trim() !== "");
      return design.rows.some(
        row =>
          Array.isArray(row.items) &&
          row.items.some(
            item =>
              withFormula(item) ||
              (Array.isArray(item && item.fields) && item.fields.some(withFormula))
          )
      );
    }
  }
};
</script>
<style lang="scss" scoped>
/* §4.3.3 form-level GNey actions editor */
.ai-actions-hint {
  margin-bottom: 0.5rem;
  font-size: 0.75rem;
  opacity: 0.75;
}
.ai-actions-row {
  display: flex;
  align-items: flex-start;
  gap: 0.375rem;
  margin-bottom: 0.375rem;
  .ai-actions-row__label {
    flex: 0 0 10rem;
  }
  .ai-actions-row__instruction {
    flex: 1;
  }
  .ai-actions-row__seniority {
    flex: 0 0 8.5rem;
  }
}
</style>
